/* eslint-disable */

import React, { useEffect, useState, useRef } from 'react';
import { useQueryParam, NumberParam, useQueryParams, StringParam, BooleanParam, withDefault } from 'use-query-params';
import ClipLoader from "react-spinners/ClipLoader";

import includesSelectedArr from '../utils/includesSelectedArr';
import arrHasSelectedItems from '../utils/arrayHasSelectedItems';

import { bedroomsInitalState, allBedroomsSelectedState, allHouseStylesSelectedState, houseStylesInitalState, distanceOptions, priceOptions } from '../data/application';

import { FilterIcon, DropIcon, DropOpenIcon, CloseIcon, HeavyDropDownIconOpen, ListIcon, MapPinIcon, LocationIcon, ListViewIcon } from '../icons';

import DevelopmentCard from '../components/DevelopmentCard';
import CheckboxFilter from '../components/CheckboxFilter';
import Autocomplete from '../components/Autocomplete';
import MapView from '../components/MapView';
import Loader from '../components/Loader';
import MobileLoader from '../components/MobileLoader';

import { getNearbyDevelopments } from '../../../api/index';

import useDevelopmentSearch from '../hooks/useDevelopmentSearch';

const DevelopmentListing = () => {

  const node = useRef();

  // Searched Developments Results
  const [developments, setDevelopments] = useState([]);

  // Outside Radius Developments
  const [outsideRadiusDevelopments, setOutsideRadiusDevelopments] = useState([]);

  // Filtering / Querying State
  const [isBespoke, setBespoke] = useQueryParam('bespoke', BooleanParam);
  const [maxPrice, setMaxPrice] = useState(0);
  const [houseStylesSelected, setHouseStyles] = useState(houseStylesInitalState);
  const [bedsSelected, setBedsSelected] = useState(bedroomsInitalState);

  // UI State
  const [houseStyleDropDownOpen, setHouseStyleDDOpen] = useState(false);
  const [bedsDropDownOpen, setBedsDDOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  // Mobile State
  const [showFilters, setShowFilters] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [showListing, setShowListing] = useState(false);

  const [searchTerm, setSearchTerm] = useQueryParam('text', StringParam);
  const [isLocationSearch, setIsLocationSearch] = useQueryParam('locationSearch', BooleanParam);
  const [showSearchBox, setSearchBoxVisiblity] = useState(false);

  const defaultDistance = 10000;

  // Coords & Distance.
  const [coords, setCoords] = useQueryParams({
    lat: withDefault(NumberParam, 52.0795991),
    lng: withDefault(NumberParam, -1.7733696),
    distance: withDefault(NumberParam, 10000)
  });

  const {
    value,
    developmentResults,
    predictivePlaceResults,
    loadingLocation,
    geoPosition,
    onPredictiveSearchChange,
    onGetUsersLocation,
    setPlace,
    searchableDevelopments
  } = useDevelopmentSearch({ searchTerm, setSearchTerm, setSearchBoxVisiblity, setIsLocationSearch });

  useEffect(() => {
    if (geoPosition.latitude && geoPosition.longitude) {
      setCoords({ lat: geoPosition.latitude, lng: geoPosition.longitude, distance: coords.distance === defaultDistance ? 30 : coords.distance });
      setIsLocationSearch(true);
    }
  }, [geoPosition]);


  
  useEffect(() => {
    const viewportWatcher = () => {
      let newViewportWidth = window.innerWidth || document.documentElement.clientWidth;
      if (newViewportWidth >= 1024) {
        setShowFilters(true);
        setShowMap(true);
        setShowListing(true);
      } else {
        setShowListing(false);
        setShowFilters(false);

      }
    };
  
    // Initial call to set the state based on the initial viewport width
    viewportWatcher();
  
    // Event listener for changes in viewport width
    window.addEventListener('resize', viewportWatcher);
  
    // Cleanup function to remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', viewportWatcher);
    };

    !isLocationSearch && onGetUsersLocation();

  }, []); // Empty dependency array ensures this effect runs only once, similar to componentDidMount
  

  const [viewportWidth, setViewportWidth] = useState(window.innerWidth || document.documentElement.clientWidth);

useEffect(() => {
  const handleResize = () => {
    setViewportWidth(window.innerWidth || document.documentElement.clientWidth);
  };

  window.addEventListener('resize', handleResize);
  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);

  // Fetch User-defined Queried Developments
  useEffect( async () => {
    setLoading(true);
    if (searchableDevelopments.length >= 1) {
      fetchDevelopments();
    }
  }, [isBespoke, houseStylesSelected, bedsSelected, coords, maxPrice, searchableDevelopments]);

  const fetchOutsideRadiusDevelopments = async () => {
    const fetch = await getNearbyDevelopments(coords, true, false);
    if (fetch) {
      // filter them so they are inline with user-defined filtering...
      const filteredArr = await filterDevelopments(fetch.data);
      setOutsideRadiusDevelopments(filteredArr);
      setLoading(false);
    }
  };

  const fetchDevelopments = async () => {
    try {
      const fetch = await getNearbyDevelopments(coords, false);

      if (fetch) {
        const filteredArr = await filterDevelopments(fetch.data);
        let developmentsFound = fetch.data.length;
        setDevelopments(filteredArr);

        // There are developments outside of radius parameters given that can be shown to the user.
        if (developmentsFound < searchableDevelopments.length) {
          // If so grab them...
          fetchOutsideRadiusDevelopments();
        } else {
          outsideRadiusDevelopments.length >= 1 && setOutsideRadiusDevelopments([]);
          setLoading(false);
        }
      }
    } catch(err) {
    }
  }

  const countFiltersSelected = () => {
    let count = 0;
    arrHasSelectedItems(houseStylesSelected) >= 1 && count++;
    arrHasSelectedItems(bedsSelected) >= 1 && count++;
    isBespoke && count++;
    maxPrice >= 1 && count++;
    return count;
  };

  const filterDevelopments = async (data) => {
    let bedroomsArr = arrHasSelectedItems(bedsSelected) >= 1 ? bedsSelected : allBedroomsSelectedState;
    let houseStylesArr = arrHasSelectedItems(houseStylesSelected) >= 1 ? houseStylesSelected : allHouseStylesSelectedState;
    let maxPriceValue = maxPrice > 0 ? maxPrice : 10000000000;

    const filteredDevelopments = data.filter(development => {
      if (!isBespoke) {
        if (includesSelectedArr(development.bedrooms, bedroomsArr)
          && includesSelectedArr(development.house_styles, houseStylesArr)
          && maxPriceValue >= development.lowest_price) {
          return development;
        }
      } else {
        if (development.is_bespoke === isBespoke
          && includesSelectedArr(development.bedrooms, bedroomsArr)
          && includesSelectedArr(development.house_styles, houseStylesArr)
          && maxPriceValue >= development.lowest_price) {
          return development;
        }
      }
    });
    return filteredDevelopments;
  };

  const onIndividualValueChange = (e, setState) => setState(e.target.value);

  const onDistanceChange = (e) => setCoords({ ...coords, distance: e.target.value })

  const onReset = () => {
    setBedsSelected(bedroomsInitalState);
    setHouseStyles(houseStylesInitalState);
    setMaxPrice(0);
    setBespoke(false);
  };

  const onBespokeChange = (e) => e.target.checked ? setBespoke(true) : setBespoke(false);

  const onCheckboxChange = (e, state, setState) => {
    const getTargetKey = state.findIndex(item => item.value === e.target.value);
    let newArray = [ ...state ];
    newArray[getTargetKey] = {
      ...newArray[getTargetKey],
      selected: !newArray[getTargetKey].selected
    };
    setState(newArray);
  };

  const onHouseStyleDropClick = () => {
    setHouseStyleDDOpen(!houseStyleDropDownOpen);
    if (bedsDropDownOpen) {
      setBedsDDOpen(false);
    }
  };

  const onBedsDropClick = () => {
    setBedsDDOpen(!bedsDropDownOpen);
    if (houseStyleDropDownOpen) {
      setHouseStyleDDOpen(false);
    }
  };

  const handleMarkerClick = async (markerId) => {

    let developmentCards = document.querySelectorAll('.development-card');
    const scrollOptions = { behavior: 'smooth', block: 'nearest' };

    // Remove Current UI Modifiers
    developmentCards.forEach(i => {
      if (i.classList.contains('development-card--selected')) {
        i.classList.remove('development-card--selected');
      }
    });

    // Apply selected UI
    developmentCards.forEach(card => {
      const { id } = card.dataset;
      if (id == markerId) {
        card.classList.toggle('development-card--selected');
        card.scrollIntoView(scrollOptions);
      }
    });
  }

  const returnSearchedResults = () => {
      return (
        developments.length >= 1 ? developments.map(item => {
          return <DevelopmentCard isLocationSearch={isLocationSearch} key={item.id} item={item} coords={coords} />
        }) :
        <div className="development-listing__message">
          <p className="development-listing__message-text">Sorry, we don’t have any developments within your search criteria</p>
        </div>
      )
  }

  const returnOutsideRadiusResults = () => {
    return (
      <div className="development-listing__outside-radius">
        {developments.length >= 1 ? <h2 className="development-listing__heading development-listing__heading--margin">Results outside of your search ({coords.distance} miles+)</h2> : <p className="development-listing__message-text development-listing__message-text--small">Here are the closest:</p>}
        {outsideRadiusDevelopments.map(item => <DevelopmentCard isLocationSearch={isLocationSearch} key={item.id} item={item} coords={coords} />)}
      </div>
    )
  }

  const displayBedroomsSelected = () => {
    let arr = bedsSelected.filter(bed => bed.selected);
    let sortedArr = arr.sort((a, b) => a - b);
    return sortedArr.map((item, i, currentArr) => {
       return currentArr.length - 1 === i ? `${item.value} ` : `${item.value}, `;
    });
  };

  let hasFilters = countFiltersSelected();
  let filtersCount = hasFilters >= 1 ? `(${hasFilters})` : null;

  const onChangeView = () => {
    setShowMap(!showMap);
    setShowListing(!showListing);
  };


  const [isListViewActive, setIsListViewActive] = useState(false);

  const handleButtonClick = () => {
    setIsListViewActive(prevState => !prevState);
  };

  return (
    <>
    <div className="search-filters">
      <div className="search-filters__container">
        <div className="search-filters__input-control search-filters__column">
          { showSearchBox ?
            <Autocomplete
              developmentResults={developmentResults}
              predictivePlaceResults={predictivePlaceResults}
              onGetPlace={setPlace}
              large={true}
              value={value}
            />
          : null }
          <div className="search-filters__input-container">
            <input onChange={onPredictiveSearchChange} className="search-filters__input" value={value} placeholder="Search by postcode or area.."/>
            <span className="search-filters__geo-location" onClick={onGetUsersLocation}> {loadingLocation ? <ClipLoader size={17} color={"#74746D"} loading={true}/> : <LocationIcon /> } </span>
          </div>
          {!isLocationSearch ?
            (
              <select onChange={onDistanceChange} value={coords.distance} className="search-filters__distance">
                <option value="30">30 Miles</option>
              </select>
             ) : (
               <select onChange={onDistanceChange} value={coords.distance} className="search-filters__distance">
                {distanceOptions.map((item, index) => <option value={item} key={index}>{item} miles</option>)}
              </select>
            )
          }
          <div className="search-filters__view-bar">
            <button className="search-filters__view-barBtn" onClick={() => setShowFilters(!showFilters)}>
               {filtersCount} {showFilters ? <CloseIcon /> : <FilterIcon />}
            </button>
        </div>
        </div>



        {showFilters &&

        <>

        <div className={`search-filters__item search-filters__column`}>
          <select onChange={(e) => onIndividualValueChange(e, setMaxPrice)} value={maxPrice} className="search-filters__item-select">
            <option value="0">Max Price</option>
            {priceOptions.map((price, index) => <option value={price} key={index}>{new Intl.NumberFormat('en-GB', { currency: 'GBP', style: 'currency', minimumFractionDigits: 0}).format(price)}</option>)}
          </select>
        </div>

        <div className={`search-filters__item  search-filters__column search-filters__item--has-drop ${bedsDropDownOpen ? 'search-filters__item--has-drop--active' : ''}`}>
          <button className="search-filters__drop-button" onClick={onBedsDropClick}> { arrHasSelectedItems(bedsSelected) >= 1 ? displayBedroomsSelected() : null} { arrHasSelectedItems(bedsSelected) >= 1 ? 'Beds' : 'Bedrooms' } {bedsDropDownOpen ? <DropOpenIcon /> : <DropIcon /> }</button>
            <div className={`search-filters__drop ${bedsDropDownOpen ? 'search-filters__drop--active' : ''}`}>
              <ul className="search-filters__drop-list">
              {bedsSelected.map((bedroom, key) => {
                return (
                  <li className="search-filters__drop-item" key={key}>
                    <input type="checkbox" name="bedsSelected" className="search-filters__checkbox" checked={bedroom.selected} value={bedroom.value} onChange={(e) => onCheckboxChange(e, bedsSelected, setBedsSelected)} />
                    <label className="search-filters__item-label">{bedroom.value} beds</label>
                  </li>
                )
              })}
              </ul>
            </div>
        </div>

        <div className={`search-filters__item search-filters__column search-filters__item--has-drop ${houseStyleDropDownOpen ? 'search-filters__item--has-drop--active' : ''}`}>
            <button className="search-filters__drop-button" onClick={onHouseStyleDropClick}>House Style {arrHasSelectedItems(houseStylesSelected) >= 1 ? `(${arrHasSelectedItems(houseStylesSelected)})` : null } {houseStyleDropDownOpen ? <DropOpenIcon /> : <DropIcon /> }</button>
              <div className={`search-filters__drop ${houseStyleDropDownOpen ? 'search-filters__drop--active' : ''}`}>
                <ul className="search-filters__drop-list">{houseStylesSelected.map((style, key) => <CheckboxFilter label={style.label} key={key} value={style.value} checked={style.selected} onHouseStyleChange={(e) => onCheckboxChange(e, houseStylesSelected, setHouseStyles)} />)}</ul>
              </div>
        </div>

        <div className="search-filters__item search-filters__column">
          <input type="checkbox" name="bespoke" checked={isBespoke} onChange={onBespokeChange} className="search-filters__checkbox"/>
          <label className="search-filters__item-label">Bespoke Collection</label>
        </div>

        </>
        }
      </div>
    </div>

    <section className="development-listing" ref={node}>
      <div 
      className={`development-listing__wrap${isListViewActive ? ' development-listing__wrap--info' : ''}`}>
      <button className={`development-listing__button${isListViewActive ? ' development-listing__button--list-view' : ''}`} onClick={handleButtonClick}>
        {isListViewActive ?  <><MapPinIcon/> Map View</> : <><ListViewIcon/> List View</>}
      </button>
      {<div className={`development-listing__column development-listing__column--results ${showListing && 'development-listing__column--active' } ${isListViewActive ? 'development-listing__column--active' : ''}`}>


        
        <div className="development-listing__column-header">
          <h2 className="development-listing__heading"><strong>{developments.length}</strong> developments {isLocationSearch ? `within ${coords.distance} miles` : null }</h2>
          {hasFilters >= 1 && <button className="development-listing__reset text-link-uppercase text-link-uppercase--grey text-link-uppercase--button" onClick={onReset}>reset</button>}
        </div>


        {!loading && hasFilters ? <MobileLoader /> : null }
        

        {viewportWidth >= 1024 && (
          loading ? <Loader /> :
            <div className="development-listing__cards">
              {returnSearchedResults()}
              {outsideRadiusDevelopments.length >= 1 && isLocationSearch ? returnOutsideRadiusResults() : null}
            </div>
        )}


      </div>}
      </div>
      {viewportWidth < 1024 && (
          loading ? <Loader /> :
            <div className={`development-listing__cards${isListViewActive ? ' development-listing__cards--active' : ''}`}>
              <div className='development-listing__wrap development-listing__wrap--cards'>
                {returnSearchedResults()}
                {outsideRadiusDevelopments.length >= 1 && isLocationSearch ? returnOutsideRadiusResults() : null}
              </div>
            </div>
        )}

   <div className={`development-listing__column development-listing__column--map development-listing__column--active ${isListViewActive ? 'development-listing__column--hidden' : ''}`}>
        <MapView
          isLocationSearch={isLocationSearch}
          coords={coords}
          developments={developments}
          outsideRadiusDevelopments={outsideRadiusDevelopments}
          handleMarkerClick={handleMarkerClick}
          loading={loading}
        />
      </div>
    
    </section>
    </>
  );
};

export default DevelopmentListing;